module.exports = __webpack_public_path__ + "static/img/about-nicole.f321c633.jpg";